import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=afcb5dbe&"
import script from "./Faq.vue?vue&type=script&lang=js&"
export * from "./Faq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afcb5dbe')) {
      api.createRecord('afcb5dbe', component.options)
    } else {
      api.reload('afcb5dbe', component.options)
    }
    module.hot.accept("./Faq.vue?vue&type=template&id=afcb5dbe&", function () {
      api.rerender('afcb5dbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/fragments/Faq.vue"
export default component.exports